export default function ReadOnly({ value }) {
    return value
}
